import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Salto from './paginas/Salto';
import Barra from './paginas/Barra';
import Viga from './paginas/Viga';
import Piso from './paginas/Piso';
import Home from './paginas/Home';
import Resultados from './paginas/Resultados';
import AgregarPuntaje from './paginas/AgregarPuntaje';
import ProtectedRoute from './componentes/ProtectedRoute';
import IniciarSesion from './paginas/IniciarSesion';
import { auth } from './firebase.js';
import ResultadosSalto from './paginas/ResultadosSalto';
import ResultadosBarra from './paginas/ResultadosBarra';
import ResultadosViga from './paginas/ResultadosViga';
import ResultadosPiso from './paginas/ResultadosPiso';
import ResultadosAA from './paginas/ResultadosAA.js';
import Bienvenidos from './paginas/Bienvenidos';
import Felicidades from './paginas/Felicidades';
import AgregarFelicidades from './paginas/AgregarFelicidades';

// Responsable por dependiendo del URL mostrar pagina correspondiente
function App() {
  const [user, setUser] = useState(null);
  const [scoreType, setScoreType] = useState('');
  const [numberJudges, setNumberJudges] = useState(0);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
        return;
      } 
      setUser(null);
    });
    return () => unsubscribe();
  }, []);

  // Get config 
  useEffect(() => {
    console.log('requesting config');
    const fetchConfig = async () => {
      try {
          const response = await fetch(`https://infinitygymnastics-app-d76b087a1ffe.herokuapp.com/getConfig`, {
              method: 'GET',
              headers: {
                  'Content-Type': 'application/json',
              },
              });
  
          if (!response.ok) {
              throw new Error(`Request failed with status: ${response.status}`);
          }
          const data = await response.json();
          if (data) {
            setScoreType(data.scoreType);
            setNumberJudges(data.numJudges);
          }
      } catch (error) {
          console.error('Error obteniendo nombres', error);
      }
    };
    fetchConfig();
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<IniciarSesion/>}/>
        <Route path="/home" element={<ProtectedRoute user={user} element={<Home />} />}/>
        <Route path="/salto" element={<ProtectedRoute user={user} element={<Salto />} />}/>
        <Route path="/barra" element={<ProtectedRoute user={user} element={<Barra />} />}/>
        <Route path="/viga" element={<ProtectedRoute user={user} element={<Viga />} />}/>
        <Route path="/piso" element={<ProtectedRoute user={user} element={<Piso />} />}/>
        <Route path="/puntaje" element={<ProtectedRoute user={user} element={<AgregarPuntaje scoreType={scoreType} numberJudges={numberJudges}/>} />}/>
        <Route path="/resultados" element={<ProtectedRoute user={user} element={<Resultados />} />}/>
        <Route path="/resultadosSalto" element={<ProtectedRoute user={user} element={<ResultadosSalto />} />}/>
        <Route path="/resultadosBarra" element={<ProtectedRoute user={user} element={<ResultadosBarra />} />}/>
        <Route path="/resultadosViga" element={<ProtectedRoute user={user} element={<ResultadosViga />} />}/>
        <Route path="/resultadosPiso" element={<ProtectedRoute user={user} element={<ResultadosPiso />} />}/>
        <Route path="/resultadosAA" element={<ProtectedRoute user={user} element={<ResultadosAA />} />}/>
        <Route path="/bienvenidos" element={<ProtectedRoute user={user} element={<Bienvenidos />} />}/>
        <Route path="/felicidades" element={<ProtectedRoute user={user} element={<Felicidades />} />}/>
        <Route path="/agregarFelicidades" element={<ProtectedRoute user={user} element={<AgregarFelicidades />} />}/>
      </Routes>
    </Router>
  );
}

export default App;